<template>
	<div>
		<product-detail-submenu />

		<core-layout-content full>
			<core-layout-headline-and-actions>
				<template slot="headline">
					{{ $t("benefits") }}
				</template>
			</core-layout-headline-and-actions>

			<!-- Body -->
			<div class="flex wrap xs-12">
				<!-- Language selector -->
				<div class="xs-12">
					<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
						<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
						<core-select-locale
							class="xs-12"
							size="xsmall"
							v-model="selectedLocale"
						/>
					</div>
				</div>

				<template v-if="benefits.length > 0 && !isLoading">
					<!-- Tree of Benefits -->
					<div class="xs-12 lg-6 lg-pr2">
						<j-card class="xs-12 bg5 p2">
							<template>
								<div class="mb4">
									<j-button
										class="mr1"
										type="primary"
										size="xsmall"
										@click="$modal.show('add_benefit')"
									>
										<crm-icon name="add" size="small" color="c5" />
										{{ $t("add_benefit") }}
									</j-button>
								</div>

								<benefit-tree
									:benefits="benefits"
									@selected="setSelectedNode"
									@addChildBenefit="$modal.show('add_child_benefit')"
									@removeBenefit="removeBenefit"
									@showUpdateNameModal="showUpdateNameModal"
								/>
							</template>
						</j-card>
					</div>

					<!-- Selected Benefit -->
					<div class="xs-12 lg-6 lg-pl2 mt2 lg-mt0">
						<j-card class="xs-12 bg5 xs-wrap" v-if="selectedNode">
							<div class="p2 xs-12 xs-wrap lh150">
								<!--
									<pre><code>{{ JSON.stringify(cleanNode, null, 2) }}</code></pre>
								 -->
								<div class="xs pb4">
									<h4>{{ $t("benefit_inspector") }}</h4>
								</div>
								<div class="xs pb1">
									<span class="fw7 mr2">{{ $t("name") }}:</span>
									<span>{{ cleanNode.name }}</span>
								</div>
								<div class="xs">
									<span class="fw7 mr2">{{ $t("value") }}:</span>
									<span>{{ cleanNode.value }}</span>
								</div>
							</div>
						</j-card>
					</div>
				</template>

				<template v-if="(!benefits || !benefits.length) && !isLoading">
					<div class="xs-12 lg-6 lg-pr2">
						<j-card class="xs-12 bg5 p2">
							<template>
								<div class="xs-12">
									<div class="lh125 fs5 fw7 mb1">
										{{ $t("create_first_benefit") }}
									</div>
									<div class="c6 lh125">
										{{ $t("benefits_explanation") }}
									</div>
								</div>
								<div class="xs-12 pt2 pb2 mt2">
									<j-button
										type="primary"
										@click="
											() => {
												selectedNode = null
												$modal.show('add_benefit')
											}
										"
									>
										{{ $t("create_benefit") }}
									</j-button>
								</div>
							</template>
						</j-card>
					</div>
				</template>
				<template v-else>
					<j-spinner v-if="isLoading" />
				</template>
			</div>
		</core-layout-content>

		<core-modal name="add_benefit" :headline="$t('add_benefit')" width="400">
			<add-benefit
				@hide="$modal.hide('add_benefit')"
				@addCustomBenefit="addBenefit"
			/>
		</core-modal>

		<core-modal
			name="add_child_benefit"
			:headline="$t('add_child_benefit')"
			width="400"
		>
			<add-benefit
				:selectedNode="selectedNode"
				@hide="$modal.hide('add_child_benefit')"
				@addCustomBenefit="addBenefit"
			/>
		</core-modal>

		<core-modal
			name="update_benefit"
			:headline="$t('update_benefit')"
			width="400"
		>
			<!-- update benefit -->
			<update-benefit @updateName="updateName" :node="selectedNode" />
		</core-modal>
	</div>
</template>

<script>
import AddBenefit from "../components/AddBenefit"
import BenefitTree from "../components/BenefitTree"
import CrmIcon from "@/components/CrmIcon"
import UpdateBenefit from "../components/UpdateBenefit"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JSpinner from "@/components/JSpinner/"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreModal from "@/modules/core/components/CoreModal"
import ProductDetailSubmenu from "../components/ProductDetailSubmenu"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		AddBenefit,
		"benefit-tree": BenefitTree,
		CoreFormInput,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreModal,
		CrmIcon,
		JCard,
		JButton,
		JSpinner,
		ProductDetailSubmenu,
		UpdateBenefit,
		CoreSelectLocale
	},

	props: {
		plan: { type: String, required: true },
		type: { type: String, required: true },
		version: {
			validator: val => typeof val === "string" || val === null,
			required: true,
			default: null
		}
	},

	data() {
		return {
			selectedNode: null,
			isLoading: false,
			list: [],
			selectedLocale: i18n.locale,
			node: null,
			benefitInput: {
				currencyCode: null
			},
			benefits: [],
			product: null
		}
	},

	computed: {
		cleanNode() {
			const node = this.selectedNode

			const nonNullValue = node => {
				if (!node || node.value === null || node.value === undefined)
					return null

				const [key, value] = Object.entries(node.value).find(
					([key, value]) => value !== null
				)

				return value
			}

			// const cleanseNode = node => {
			// 	if (!node?.children || !node?.children?.length)
			// 		return {
			// 			name: node.name,
			// 			value: nonNullValue(node)
			// 		}

			// 	if (node.children?.length > 0)
			// 		return {
			// 			name: node.name,
			// 			value: nonNullValue(node),
			// 			children: node.children.map(child => cleanseNode(child))
			// 		}
			// }

			return {
				name: node.name,
				value: nonNullValue(node)
			}
		}
	},

	methods: {
		setSelectedNode(node) {
			this.selectedNode = node
		},
		async getProduct() {
			const { plan, version, type } = this

			const res = await api.getProductBenefits(
				{
					where: { productId: { plan, version, type } }
				},
				this.selectedLocale
			)

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			const massageChildren = benefit => {
				if (!benefit) return
				if (!benefit.children?.length) {
					return {
						...benefit,
						hasChildren: () => false,
						tooDeep: () => (benefit?.children ? false : true)
					}
				}
				if (benefit.children.length > 0) {
					return {
						...benefit,
						hasChildren: () => true,
						tooDeep: () => (benefit.children ? false : true),
						children: benefit.children.map(child => massageChildren(child))
					}
				}
			}

			const product = get(res.data.product, "list[0]")
			const benefits = get(product, "benefitGraph", [])

			this.product = product
			this.benefits = benefits?.map(massageChildren) || []
		},

		// todo:
		async addChildBenefit(benefit) {
			this.selectedNode = benefit
			this.$modal.show("add_child_benefit")
		},
		async addBenefit(benefit) {
			this.$modal.hide("add_benefit")
			this.$modal.hide("add_child_benefit")

			const { plan, version, type } = this
			const productId = { plan, version, type }

			const res = await api.addBenefit({
				productId,
				input: {
					typeId: benefit.typeId,
					value: benefit.value,
					parentTypeId: benefit.parentTypeId || null
				}
			})

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			const updateName = await api.localizeProduct({
				l10n: {
					key: `benefits-${benefit.typeId}-name`,
					value: benefit.name,
					locale: this.selectedLocale
				}
			})

			if (updateName.errors) {
				this.$store.dispatch("showError", updateName.errors)
				return
			}

			// console.log(res, updateName)
			this.$store.dispatch("showSuccess", "Yay, the benefit has been added.")

			await this.getProduct()
		},

		showUpdateNameModal(node) {
			this.$modal.show("update_benefit")
			this.selectedNode = node
		},
		async updateName(name) {
			this.$modal.hide("update_benefit")
			const benefit = this.selectedNode

			const updateName = await api.localizeProduct({
				l10n: {
					key: `benefits-${benefit.typeId}-name`,
					value: name,
					locale: this.selectedLocale
				}
			})

			if (updateName.errors) {
				this.$store.dispatch("showError", updateName.errors)
				return
			}

			// console.log(res, updateName)
			this.$store.dispatch(
				"showSuccess",
				"Yay, the benefit name has been updated."
			)

			await this.getProduct()
		},

		// remove benefit
		async removeBenefit(node) {
			const { plan, version, type } = this
			let res = await api.removeBenefit({
				productId: {
					plan,
					version,
					type
				},
				typeId: node.typeId
			})

			// remove selectedNode
			this.selectedNode = null

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Delete locale
			res = await api.deleteAllL10n({
				key: `benefits-${node.typeId}-name`
			})

			await this.getProduct()
		}
	},

	async created() {
		// Check if we are receiving all props
		// If not, redirect to products listing
		if (
			typeof this.plan === "undefined" ||
			typeof this.type === "undefined" ||
			typeof this.version === "undefined"
		) {
			this.$router.push({ name: "ProductsList" })
			return
		}

		// Fetch product info
		this.isLoading = true
		await this.getProduct()
		this.isLoading = false
	},

	watch: {
		selectedLocale: {
			handler(o, n) {
				if (o && n) {
					this.getProduct()
				}
			}
		}
	}
}
</script>
